import axiosInstance from "../axiosInstance";
import { dispatch, store } from "../../redux/store";
export const getMatchMakerFeed = async (body: any) => {
  const requestBody = JSON.parse(body); // Parse JSON string to object
  console.log("body", requestBody?.page, requestBody?.pageSize);


  try {
    const { userToken } = store.getState().user;
    // const apiUrl = `http://192.168.1.6:3000/match-maker/getFeed?page=${requestBody.page}&pageSize=${requestBody.pageSize}`;
    const apiUrl = `https://api-dev.spark.hushl.in/match-maker/getFeed?page=${requestBody.page}&pageSize=${requestBody.pageSize}`;
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: body,
    });
    return response;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const matchEdit = async (body: any) => {
  try {
    const data = await axiosInstance.put("user/match-edit", body);
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const likeEdit = async (body: any) => {
  try {
    const data = await axiosInstance.put("user/like-user", body);
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const pickupGenerater = async (body: any) => {
  try {
    const data = await axiosInstance.post("ai/generate-pickup-lines", body);
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};

export const reportUser = async (body: any) => {
  try {
    const data = await axiosInstance.post("user/report", body);
    return data;
  } catch (error) {
    // console.log("Error logging in:", error);
  }
};
